import React from 'react';

const SparklineChart = ({ data, width = 80, height = 24, color = "var(--color-primary, #4A90E2)", isDown = false }) => {
  if (!data || data.length === 0) return null;

  // Garantir Y bounds de 0 a 100 (percentage)
  const minY = 0;
  const maxY = 100;

  // Gerar path SVG
  let pathD = "";
  const len = data.length;
  const xStep = width / (len > 1 ? len - 1 : 1);

  data.forEach((point, i) => {
    // Inverter Y porque SVG coordenadas Y crescem para baixo
    const py = height - ((point.nivel_percentual - minY) / (maxY - minY)) * height;
    const px = i * xStep;

    if (i === 0) pathD += `M ${px} ${py}`;
    else pathD += ` L ${px} ${py}`;
  });

  const strokeColor = isDown ? "var(--color-danger, #ef4444)" : color;

  return (
    <div className="sparkline-base" title="Nível nas últimas 24h">
      <svg width="100%" height="100%" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" className="sparkline-svg">
        <path
          d={pathD}
          fill="none"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default SparklineChart;
